import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53252960"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReportListItem" }
const _hoisted_2 = { class: "flex items-center justify-between mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "Пользователь: " + _toDisplayString(_ctx.item.user), 1)
    ]),
    _createElementVNode("span", null, "Количество доставок: " + _toDisplayString(_ctx.item.delivered), 1),
    _createElementVNode("span", null, "Итого: " + _toDisplayString(_ctx.item.total), 1)
  ]))
}